import React from "react";
import { capacityStatus } from "@/lib/inventoryApi";

/**
 * Capacity progress bar. Green < 70%, amber 70-89%, red ≥ 90% — matches the
 * spec so ops can eyeball the emptiest bin from a picker row.
 */
export default function CapacityBar({ location, compact = false }) {
  const { pct, tone, current, capacity } = capacityStatus(location);

  if (pct == null) {
    return (
      <div
        className="text-[10px] uppercase tracking-[0.15em] text-zinc-400 font-semibold"
        data-testid="capacity-unknown"
      >
        capacity —
      </div>
    );
  }

  const barColors = {
    green: "bg-emerald-500",
    amber: "bg-amber-500",
    red: "bg-red-500",
  };
  const textColors = {
    green: "text-emerald-700 dark:text-emerald-400",
    amber: "text-amber-700 dark:text-amber-400",
    red: "text-red-700 dark:text-red-400",
  };
  const pctDisplay = Math.round(pct);

  return (
    <div className={`w-full ${compact ? "" : "space-y-1"}`} data-testid={`capacity-bar-${tone}`}>
      {!compact && (
        <div className="flex items-baseline justify-between text-[11px] font-mono">
          <span className="text-zinc-500">
            {current} / {capacity}
          </span>
          <span className={`font-bold ${textColors[tone]}`}>{pctDisplay}%</span>
        </div>
      )}
      <div
        className={`w-full ${compact ? "h-1" : "h-1.5"} rounded-full bg-zinc-200 dark:bg-zinc-800 overflow-hidden`}
      >
        <div
          className={`h-full ${barColors[tone]} transition-all`}
          style={{ width: `${Math.min(100, pctDisplay)}%` }}
        />
      </div>
      {compact && (
        <div className={`text-[10px] font-mono mt-0.5 ${textColors[tone]}`}>
          {current} / {capacity} · {pctDisplay}%
        </div>
      )}
    </div>
  );
}
